<dspx-spinner></dspx-spinner>
<div class="layout-wrapper"
     (click)="menuConfigService.onLayoutClick()"
     [ngClass]="{
        'menu-layout-static': menuConfigService.styleConfigService.layoutMode !== 'overlay',
        'menu-layout-overlay': menuConfigService.styleConfigService.layoutMode === 'overlay',
        'layout-menu-overlay-active': menuConfigService.overlayMenuActive,
        'menu-layout-slim': menuConfigService.styleConfigService.layoutMode === 'slim',
        'menu-layout-horizontal': menuConfigService.styleConfigService.layoutMode === 'horizontal',
        'layout-menu-static-inactive': menuConfigService.staticMenuDesktopInactive,
        'layout-menu-static-active': menuConfigService.staticMenuMobileActive,
        'p-input-filled': menuConfigService.styleConfigService.inputStyle === 'filled',
        'p-ripple-disabled': !menuConfigService.styleConfigService.ripple
      }">
  <dspx-card-set-header [config]="headerConfig"></dspx-card-set-header>
  <dspx-card-set-menu [config]="menuConfig"></dspx-card-set-menu>

  <div class="layout-main">
    <div class="breadcrumbContainer pb-3">
      <dspx-breadcrumb id="appBreadcrumbs"></dspx-breadcrumb>
    </div>
    <dspx-environment-banner [message]="environmentBannerMessage"
                             [bgcolor]="environmentBannerBgColor"
                             [color]="environmentBannerColor"
                             [topDividerDisplay]="'never'"
                             [bottomDividerDisplay]="'auto'">
    </dspx-environment-banner>
    <router-outlet></router-outlet>
  </div>

  <div class="layout-mask"></div>

  <dspx-card-set-footer [config]="footerConfig"></dspx-card-set-footer>
</div>
